const state= {

};

const getters = {
    
};

const actions = {
    async importItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();

            if ( !['DORJ Attachments', 'INVOICE Attachments', 'WO Attachments', 'WO Attachments (Read Content File)'].includes(params.file_type) ) {
                formData.append('file_import', params.file_import);
            } else {
                for (var i = 0; i < params.file_import.length; i++) {
                    let file = params.file_import[i];
                    formData.append('file_import[' + i + ']', file);
                }
            }
            
            if(params.contract_id) {
                formData.append('contract_id', params.contract_id);
            }
            formData.append('file_type', params.file_type);
           
            if(params.lmu_inbound_log_id){
                formData.append('lmu_inbound_log_id', params.lmu_inbound_log_id);
            }

            if(params.supplier_id){
                formData.append('supplier_id', params.supplier_id);
            }
            
            global.axios.post(`/api/lmu-adhoc/import`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },
    async getImportLog({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/lmu-adhoc/import-log`, {params:params})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async getBatchSubmission({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/lmu-adhoc/batch-submission`, {params:params})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async getBatchHeader({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/lmu-adhoc/batch-header/${params.id}`, {
                method: "GET",
                params: {},
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async getBatchEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/lmu-adhoc/batch-entries/${params.id}`, {params: params.data})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async getBatchError({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/lmu-adhoc/batch-error/${params.id}`, {params: params.data})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    //
    async getIncomingDocuments({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/lmu-adhoc/incoming-documents`, {params:params})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    //
    async updateStatus({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`/api/lmu-adhoc/incoming-documents`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async importItemsSFTP({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
 
            formData.append('file_type', params.file_type);
            formData.append('submission_mode', params.submission_mode);
            formData.append('supplier_id', params.supplier_id || '');
            global.axios.post(`/api/lmu-adhoc/import-sftp`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    }
};

const mutations = {
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
